import styled from 'styled-components';
import colors from '@designSystem/colors';

export const MenuStyle = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LastUpdate = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;

  & svg {
    margin-right: 8px;
    width: 12px;
    height: 12px;

    path {
      fill: ${colors.grey};
    }
  }
`;

export const LastUpdateSpan = styled.span`
  color: ${colors.grey};
  margin-right: 8px;
`;

export const LastUpdateDateSpan = styled.span`
  color: ${colors.black};
`;
